// El intento de una operación sobre un recurso; sobrevive a renders y a desmontar el diálogo.
import { attemptForScope, type IdempotentAttempt } from '@/lib/idempotentAttempt';

export function useIdempotentAttempt(scope: string): IdempotentAttempt {
    return attemptForScope(scope);
}
